import { memo, useCallback, useState } from "react";
import { TextField } from "ui/components/TextField/TextField";
import { VehicleFireExtinguisherSearchFilterProps } from "./types";
import { FleetVehicleFireExtinguisherSearchFormValues } from "services/api/fleet/vehicles/fireextinguishers/types";
import { initialFleetVehicleFireExtinguisherSearchForm } from "services/api/fleet/vehicles/fireextinguishers/consts";
import { useTranslate } from "helpers";

const VehicleFireExtinguisherSearchFilters: React.FC<VehicleFireExtinguisherSearchFilterProps> = (
  props
) => {
  const { onSearchChange } = props;
  const { t } = useTranslate();

  const [formValues, setFormValues] =
    useState<FleetVehicleFireExtinguisherSearchFormValues>(
      initialFleetVehicleFireExtinguisherSearchForm
    );

  const handleSearchChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const updatedFormValues = { ...formValues, search: e.target.value };
    setFormValues(updatedFormValues);
    onSearchChange(updatedFormValues);
  };

  const handleResetFormClick = useCallback(() => {
    setFormValues(initialFleetVehicleFireExtinguisherSearchForm);
  }, []);

  return (
    <>
      <div className="flex justify-between items-center ">
        <div className="flex">
          <div className="mr-3">
            <TextField
              type="text"
              name="search"
              value={formValues.search}
              onChange={handleSearchChange}
              placeholder={t("admin.search.placeholder")}
              startIcon="/media/icons/search.svg"
              cssClassName="bg-white"
            />
          </div>

          <div className="mr-3 flex items-center">
            <span
              onClick={handleResetFormClick}
              className="text-xs font-bold cursor-pointer text-gray-700"
            >
              {t("admin.reset")}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};
export default memo(VehicleFireExtinguisherSearchFilters);
